// Vite-env read isolated into its own module so hooks that only need the
// flag stay testable under ts-jest (which can't evaluate `import.meta` at
// module load). Mirrors the existing pattern of mapping/mocking Vite-env
// modules (lib/auth, lib/analytics, lib/logger) in jest.config.
const processEnv =
  (globalThis as { process?: { env?: Record<string, string | undefined> } }).process?.env;

/**
 * Gates the scoped debug logger for the dashboard Figma OAuth flow.
 * Enabled via `VITE_DEBUG_FIX=1` (build) or `DEBUG_FIX=1` (node).
 */
export const DEBUG_FIX_ENABLED =
  ((import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env?.VITE_DEBUG_FIX === '1') ||
  processEnv?.DEBUG_FIX === '1';
